import { useRef } from "react";

// Canvas de semnătură reutilizabil. Apelează onCapture(dataUrl | null).
export default function SignaturePad({ onCapture, width = 460, height = 140 }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const hasDrawn = useRef(false);

  const pos = (e) => {
    const c = canvasRef.current;
    const rect = c.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y); ctx.strokeStyle = "#111"; ctx.lineWidth = 2; ctx.stroke();
    hasDrawn.current = true;
  };
  const end = () => { drawing.current = false; if (hasDrawn.current) onCapture(canvasRef.current.toDataURL("image/png")); };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); hasDrawn.current = false; onCapture(null); };

  return (
    <div>
      <canvas
        ref={canvasRef} width={width} height={height}
        className="w-full touch-none rounded-lg border border-border bg-white"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        data-testid="signature-canvas"
      />
      <button type="button" onClick={clear} className="mt-1 text-xs text-muted-foreground hover:text-foreground">Șterge semnătura</button>
    </div>
  );
}
